import * as React from 'react';

function Panel(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
}

export default Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/Panel/index.js
// module id = 1080
// module chunks = 0